import React from 'react'
import "./searchItem.css"

const SearchItem = () => {
  return (
    <>
    <div className='SearchItem'>
        <img src="https://cf.bstatic.com/xdata/images/hotel/square600/369457265.webp?k=1723a0296d4d90a64bf3a9836fced2a9018690af47fdaaa0c7f057f473afc101&o=&s=1" alt="" className="searchImage" />
        <div className="siDes">
            <h1 className="siTitle">Mohar Residency </h1>
            <span className="siDistance">6.6 Km kolkata</span>
            <span className="siTaxi">Travel Sustainable property</span>
            <span className="subtitle">Limited-time Deal</span>
            <span className="siFeature">Deluxe Room 1 queen bed</span>
            <span className="siCancell"> Free cancellation</span>
            <span className="siCancelSubTitle">You can cancel later, so lock in this great price today!</span>
        </div>
        <div className="siDeatils">
            <div className="siRating">
                <span>Very Good</span>
                {/* <span className='sp1'>125reviews</span> */}
                <button>8.2</button>
            </div>
            <div className="siDeatailsTexts">
                <span className="siPRice">$24.30</span>
                <span className="siTaxiOp">$3.2 Taxes and charges</span>    
                <button className="siDeatailsCheckBtn">See availabillity</button>            
            </div>
        </div>
    </div>





    <div className='SearchItem'>
        <img src="https://cf.bstatic.com/xdata/images/hotel/square600/369457265.webp?k=1723a0296d4d90a64bf3a9836fced2a9018690af47fdaaa0c7f057f473afc101&o=&s=1" alt="" className="searchImage" />
        <div className="siDes">
            <h1 className="siTitle">Mohar Residency </h1>
            <span className="siDistance">6.6 Km kolkata</span>
            <span className="siTaxi">Travel Sustainable property</span>
            <span className="subtitle">Limited-time Deal</span>
            <span className="siFeature">Deluxe Room 1 queen bed</span>
            <span className="siCancell"> Free cancellation</span>
            <span className="siCancelSubTitle">You can cancel later, so lock in this great price today!</span>
        </div>
        <div className="siDeatils">
            <div className="siRating">
                <span>Very Good</span>
                {/* <span className='sp1'>125reviews</span> */}
                <button>8.2</button>
            </div>
            <div className="siDeatailsTexts">
                <span className="siPRice">$24.30</span>
                <span className="siTaxiOp">$3.2 Taxes and charges</span>    
                <button className="siDeatailsCheckBtn">See availabillity</button>            
            </div>
        </div>
    </div>



    <div className='SearchItem'>
        <img src="https://cf.bstatic.com/xdata/images/hotel/square600/369457265.webp?k=1723a0296d4d90a64bf3a9836fced2a9018690af47fdaaa0c7f057f473afc101&o=&s=1" alt="" className="searchImage" />
        <div className="siDes">
            <h1 className="siTitle">Mohar Residency </h1>
            <span className="siDistance">6.6 Km kolkata</span>
            <span className="siTaxi">Travel Sustainable property</span>
            <span className="subtitle">Limited-time Deal</span>
            <span className="siFeature">Deluxe Room 1 queen bed</span>
            <span className="siCancell"> Free cancellation</span>
            <span className="siCancelSubTitle">You can cancel later, so lock in this great price today!</span>
        </div>
        <div className="siDeatils">
            <div className="siRating">
                <span>Very Good</span>
                {/* <span className='sp1'>125reviews</span> */}
                <button>8.2</button>
            </div>
            <div className="siDeatailsTexts">
                <span className="siPRice">$24.30</span>
                <span className="siTaxiOp">$3.2 Taxes and charges</span>    
                <button className="siDeatailsCheckBtn">See availabillity</button>            
            </div>
        </div>
    </div>


    <div className='SearchItem'>
        <img src="https://cf.bstatic.com/xdata/images/hotel/square600/369457265.webp?k=1723a0296d4d90a64bf3a9836fced2a9018690af47fdaaa0c7f057f473afc101&o=&s=1" alt="" className="searchImage" />
        <div className="siDes">
            <h1 className="siTitle">Mohar Residency </h1>
            <span className="siDistance">6.6 Km kolkata</span>
            <span className="siTaxi">Travel Sustainable property</span>
            <span className="subtitle">Limited-time Deal</span>
            <span className="siFeature">Deluxe Room 1 queen bed</span>
            <span className="siCancell"> Free cancellation</span>
            <span className="siCancelSubTitle">You can cancel later, so lock in this great price today!</span>
        </div>
        <div className="siDeatils">
            <div className="siRating">
                <span>Very Good</span>
                {/* <span className='sp1'>125reviews</span> */}
                <button>8.2</button>
            </div>
            <div className="siDeatailsTexts">
                <span className="siPRice">$24.30</span>
                <span className="siTaxiOp">$3.2 Taxes and charges</span>    
                <button className="siDeatailsCheckBtn">See availabillity</button>            
            </div>
        </div>
    </div>



    <div className='SearchItem'>
        <img src="https://cf.bstatic.com/xdata/images/hotel/square600/369457265.webp?k=1723a0296d4d90a64bf3a9836fced2a9018690af47fdaaa0c7f057f473afc101&o=&s=1" alt="" className="searchImage" />
        <div className="siDes">
            <h1 className="siTitle">Mohar Residency </h1>
            <span className="siDistance">6.6 Km kolkata</span>
            <span className="siTaxi">Travel Sustainable property</span>
            <span className="subtitle">Limited-time Deal</span>
            <span className="siFeature">Deluxe Room 1 queen bed</span>
            <span className="siCancell"> Free cancellation</span>
            <span className="siCancelSubTitle">You can cancel later, so lock in this great price today!</span>
        </div>
        <div className="siDeatils">
            <div className="siRating">
                <span>Very Good</span>
                {/* <span className='sp1'>125reviews</span> */}
                <button>8.2</button>
            </div>
            <div className="siDeatailsTexts">
                <span className="siPRice">$24.30</span>
                <span className="siTaxiOp">$3.2 Taxes and charges</span>    
                <button className="siDeatailsCheckBtn">See availabillity</button>            
            </div>
        </div>
    </div>

    <div className='SearchItem'>
        <img src="https://cf.bstatic.com/xdata/images/hotel/square600/369457265.webp?k=1723a0296d4d90a64bf3a9836fced2a9018690af47fdaaa0c7f057f473afc101&o=&s=1" alt="" className="searchImage" />
        <div className="siDes">
            <h1 className="siTitle">Mohar Residency </h1>
            <span className="siDistance">6.6 Km kolkata</span>
            <span className="siTaxi">Travel Sustainable property</span>
            <span className="subtitle">Limited-time Deal</span>
            <span className="siFeature">Deluxe Room 1 queen bed</span>
            <span className="siCancell"> Free cancellation</span>
            <span className="siCancelSubTitle">You can cancel later, so lock in this great price today!</span>
        </div>
        <div className="siDeatils">
            <div className="siRating">
                <span>Very Good</span>
                {/* <span className='sp1'>125reviews</span> */}
                <button>8.2</button>
            </div>
            <div className="siDeatailsTexts">
                <span className="siPRice">$24.30</span>
                <span className="siTaxiOp">$3.2 Taxes and charges</span>    
                <button className="siDeatailsCheckBtn">See availabillity</button>            
            </div>
        </div>
    </div>


    <div className='SearchItem'>
        <img src="https://cf.bstatic.com/xdata/images/hotel/square600/369457265.webp?k=1723a0296d4d90a64bf3a9836fced2a9018690af47fdaaa0c7f057f473afc101&o=&s=1" alt="" className="searchImage" />
        <div className="siDes">
            <h1 className="siTitle">Mohar Residency </h1>
            <span className="siDistance">6.6 Km kolkata</span>
            <span className="siTaxi">Travel Sustainable property</span>
            <span className="subtitle">Limited-time Deal</span>
            <span className="siFeature">Deluxe Room 1 queen bed</span>
            <span className="siCancell"> Free cancellation</span>
            <span className="siCancelSubTitle">You can cancel later, so lock in this great price today!</span>
        </div>
        <div className="siDeatils">
            <div className="siRating">
                <span>Very Good</span>
                {/* <span className='sp1'>125reviews</span> */}
                <button>8.2</button>
            </div>
            <div className="siDeatailsTexts">
                <span className="siPRice">$24.30</span>
                <span className="siTaxiOp">$3.2 Taxes and charges</span>    
                <button className="siDeatailsCheckBtn">See availabillity</button>            
            </div>
        </div>
    </div>


    <div className='SearchItem'>
        <img src="https://cf.bstatic.com/xdata/images/hotel/square600/369457265.webp?k=1723a0296d4d90a64bf3a9836fced2a9018690af47fdaaa0c7f057f473afc101&o=&s=1" alt="" className="searchImage" />
        <div className="siDes">
            <h1 className="siTitle">Mohar Residency </h1>
            <span className="siDistance">6.6 Km kolkata</span>
            <span className="siTaxi">Travel Sustainable property</span>
            <span className="subtitle">Limited-time Deal</span>
            <span className="siFeature">Deluxe Room 1 queen bed</span>
            <span className="siCancell"> Free cancellation</span>
            <span className="siCancelSubTitle">You can cancel later, so lock in this great price today!</span>
        </div>
        <div className="siDeatils">
            <div className="siRating">
                <span>Very Good</span>
                {/* <span className='sp1'>125reviews</span> */}
                <button>8.2</button>
            </div>
            <div className="siDeatailsTexts">
                <span className="siPRice">$24.30</span>
                <span className="siTaxiOp">$3.2 Taxes and charges</span>    
                <button className="siDeatailsCheckBtn">See availabillity</button>            
            </div>
        </div>
    </div>
    </>
  )
}

export default SearchItem
